import { type PortEnv, GEM_CUT } from './support-b3';
interface Deps { 'GemstoneSize::isBase'(id: string): boolean; }
/** PHP: ft_gemstone_passive_ids_for_roll (options/tools/inventory/random_generator/gemstone_random_pool_inc.php:259) */
export function ftGemstonePassiveIdsForRoll(sizeId: string, isCut: boolean, env: PortEnv<Deps>): string[] {
    const ids = []; if (sizeId !== '' && !env.deps['GemstoneSize::isBase'](sizeId)) ids.push(sizeId); if (isCut) ids.push(GEM_CUT); return ids;
}
